import "./askProfileDetails.scss";

import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import Datetime from "react-datetime";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router-dom";
import Typography from "../../../../../../../common/Typography";
import Button from "../../../../../../../common/Buttons/Button";
import Input from "../../../../../../../common/TextFields/Input";
// import { trackEvent } from "../../../../../../../../utils/config/analytics";
import SearchBar from "../../../../../../../common/Dropdowns/Select/SearchBar";
import AlertTriangleFilled from "../../../../../../../assets/AlertTriangleFilled";
import { scanQrCustomer } from "../../../../../../../../redux/actions/qrCodeActions";
import {
  getPlacesFromOla,
  getPlacesFromGoogle,
} from "../../../../../../../../redux/actions/utilityActions";

const AskProfileDetails = ({
  qrId,
  data,
  countryCode,
  customerPhone,
  setResponseObj,
  customerData = {},
  setSecondPageStatus,
  setConfirmationPage,
  isDemoQrPage = false,
  handleSubmit = () => {},
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const isCache = query.get("cache");

  const [isSearching, toggleSearch] = useState(false);

  const [searchedQuery, setSearchedQuery] = useState("");
  const [delayedSearchedQuery, setDelayedSearchedQuery] = useState("");

  const [selectedPlace, setSelectedPlace] = useState("");
  const [searchedResultsArr, setSearchedResultsArr] = useState([]);
  const isIndianTimezone = new Date().getTimezoneOffset() === -330;

  useEffect(() => {
    if (customerData?.address?.length > 0)
      setSelectedPlace({
        value: customerData?.address,
        label: customerData?.address,
        location: customerData?.location,
      });
  }, [customerData]);

  useEffect(() => {
    toggleSearch(true);
    const delayDebounceFn = setTimeout(() => {
      setDelayedSearchedQuery(searchedQuery);
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchedQuery]);

  useEffect(() => {
    if (delayedSearchedQuery?.length > 0) handleSearch(delayedSearchedQuery);
  }, [delayedSearchedQuery]);

  const handleSearch = (query) => {
    if (isIndianTimezone) {
      getPlacesFromOla(query)
        .then((payload) => {
          toggleSearch(false);
          const searchedOptions = payload?.map((obj) => ({
            label: `${obj?.description}`,
            value: `${obj?.description}`,
            title: obj?.structured_formatting?.main_text,
            subtitle: obj?.structured_formatting?.secondary_text,
            location: {
              latitude: obj?.geometry?.location?.lat,
              longitude: obj?.geometry?.location?.lng,
            },
          }));
          setSearchedResultsArr(searchedOptions);
        })
        .catch(() => toggleSearch(false));
    } else {
      const reqBody = {
        textQuery: query,
      };
      getPlacesFromGoogle(
        reqBody,
        "places.formattedAddress,places.location,places.displayName.text"
      )
        .then((payload) => {
          toggleSearch(false);
          const searchedOptions = payload?.map((obj) => ({
            ...obj,
            title: obj?.displayName?.text,
            subtitle: obj?.formattedAddress,
            label: `${obj?.displayName?.text}, ${obj?.formattedAddress}`,
            value: `${obj?.displayName?.text}, ${obj?.formattedAddress}`,
          }));
          setSearchedResultsArr(searchedOptions);
        })
        .catch(() => toggleSearch(false));
    }
  };

  const handleMenuClose = () => {
    setSearchedResultsArr([]);
  };

  const handleSelectPlace = (obj) => {
    setSelectedPlace(obj);
  };

  return (
    customerData && (
      <div className="ask-profile-dets-page">
        <Typography tag="h2" size="display-xl">
          We'd love to know you better! Share your details and get a reward 🎉
        </Typography>
        <Formik
          initialValues={{
            name: customerData?.name || "",
            email: customerData?.email || "",
            gender: customerData?.gender || "male",
            birthday:
              (customerData?.birthday && moment(customerData.birthday)) || "",
            anniversary:
              (customerData?.anniversary && moment(customerData.anniversary)) ||
              "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            let profileData = {
              name: values.name,
              email: values.email,
              dob: values.birthday,
              gender: values.gender,
              mobile: customerPhone,
              country_code: countryCode,
              address: selectedPlace?.label,
              anniversary: values.anniversary,
              location: selectedPlace?.location,
            };
            if (profileData.dob && !moment.isMoment(profileData.dob)) {
              const momentDate = moment(
                profileData.dob,
                "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"
              );
              if (momentDate.isValid()) {
                profileData.dob = momentDate.format("yyyy/MM/DD");
              } else {
                setSubmitting(false);
                toastr.error("Validation Error", "Not a valid birthday date");
                return;
              }
            } else if (moment.isMoment(profileData.dob)) {
              profileData.dob = profileData.dob.format("yyyy/MM/DD");
            }

            if (
              profileData.anniversary &&
              profileData.anniversary?.length > 0 &&
              !moment.isMoment(profileData.anniversary)
            ) {
              const momentDate = moment(
                profileData.anniversary,
                "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"
              );
              if (momentDate.isValid()) {
                profileData.anniversary = momentDate.format("yyyy/MM/DD");
              } else {
                setSubmitting(false);
                toastr.error(
                  "Validation Error",
                  "Not a valid anniversary date"
                );
                return;
              }
            } else if (moment.isMoment(profileData.anniversary))
              profileData.anniversary =
                profileData.anniversary.format("yyyy/MM/DD");

            if (profileData?.anniversary?.length === 0)
              delete profileData?.anniversary;

            if (isDemoQrPage) {
              setSubmitting(false);
              handleSubmit();
            } else {
              dispatch(scanQrCustomer(qrId, profileData, isCache))
                .then((payload) => {
                  setSubmitting(false);
                  setConfirmationPage(true);
                  setResponseObj(payload?.responseObj);
                  setSecondPageStatus(payload?.res_type);
                  data.allStoresArr = payload?.responseObj?.applicableStores;
                  // trackEvent("ProfileDetailsAdded", {
                  //   source: "qr_code",
                  //   is_profile_complete: true,
                  //   anniversary_entered:
                  //     profileData?.anniversary &&
                  //     profileData?.anniversary?.length > 0,
                  //   address_entered:
                  //     profileData?.address && profileData?.address?.length > 0,
                  // });
                })
                .catch((errors) => {
                  setSubmitting(false);
                  if (Array.isArray(errors)) {
                    var object = errors?.reduce((obj, item) => {
                      obj[item.param] = item.msg;
                      return obj;
                    }, {});
                    setErrors(object);
                  }
                });
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {
            return (
              <>
                <Input
                  disabled={true}
                  label="Phone Number"
                  value={customerPhone}
                />
                <Input
                  name="name"
                  label="Name"
                  error={errors.name}
                  value={values.name}
                  touch={touched.name}
                  placeholder="Your Name"
                  handleChange={handleChange}
                />
                <div className="gender-select">
                  {["male", "female"].map((gender) => (
                    <Typography
                      tag="span"
                      key={gender}
                      size="text-sm"
                      weight="medium"
                      customClass={`gender${
                        values.gender === gender ? " active-gender" : ""
                      }`}
                      onClick={() => {
                        if (!customerData?.gender)
                          setFieldValue("gender", gender);
                      }}
                    >
                      {gender}
                    </Typography>
                  ))}
                </div>
                {errors.gender && (
                  <div className="field-error">{errors.gender}</div>
                )}
                <Input
                  type="email"
                  name="email"
                  label="Email"
                  error={errors.email}
                  value={values.email}
                  touch={touched.email}
                  placeholder="Your Email"
                  handleChange={handleChange}
                  disabled={customerData?.email ? true : false}
                />
                <div className="birthday-anniversary-row">
                  {["birthday", "anniversary"].map((item) => (
                    <div key={item}>
                      <Typography
                        weight="medium"
                        size="text-md"
                        customClass="item-label"
                      >
                        {item}
                      </Typography>
                      <Datetime
                        timeFormat={false}
                        value={values[item]}
                        dateFormat="DD-MM-YYYY"
                        className="new-date-field"
                        onChange={(e) => setFieldValue(item, e)}
                        isValidDate={(current) => current.isBefore(moment())}
                        inputProps={{
                          name: item,
                          autoComplete: "off",
                          placeholder: "dd-mm-yyyy",
                          disabled: customerData?.[item] ? true : false,
                        }}
                      />
                      <Typography
                        tag="span"
                        size="text-sm"
                        customClass="field-error"
                      >
                        {errors[item]}
                      </Typography>
                    </div>
                  ))}
                </div>
                <SearchBar
                  label="Address"
                  fullWidth={true}
                  value={selectedPlace}
                  hasMoreOptions={false}
                  isSearching={isSearching}
                  inputValue={searchedQuery}
                  onMenuClose={handleMenuClose}
                  optionsList={searchedResultsArr}
                  handleSelect={handleSelectPlace}
                  placeholder="Search your address"
                  menuCustomClassName="google-places-search-menu"
                  disabled={customerData?.address ? true : false}
                  onInputChange={(inputVal) => setSearchedQuery(inputVal)}
                />
                <Button
                  type="submit"
                  text="Submit"
                  fullWidth={true}
                  disabled={isSubmitting}
                  handleClick={handleSubmit}
                  isSubmitting={isSubmitting}
                />
                <div className="alert-info">
                  <AlertTriangleFilled />
                  <Typography tag="span" size="text-sm">
                    You will not be able to edit details later.
                  </Typography>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    )
  );
};

export default AskProfileDetails;

const validationSchema = () =>
  Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .required("Please enter your email"),
    name: Yup.string().required("Please enter your name"),
    gender: Yup.string().required("Please select your gender"),
    birthday: Yup.string().required("Please select your birthday"),
  });
